import { render, staticRenderFns } from "./assign-trainer-course.vue?vue&type=template&id=768ab13a&scoped=true"
import script from "./assign-trainer-course.vue?vue&type=script&lang=js"
export * from "./assign-trainer-course.vue?vue&type=script&lang=js"
import style0 from "./assign-trainer-course.vue?vue&type=style&index=0&id=768ab13a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768ab13a",
  null
  
)

export default component.exports